/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOAccountLimitsStatusDTO } from '../models/ApiResponseDTOAccountLimitsStatusDTO';
import type { ApiResponseDTOExceededLimitsDTO } from '../models/ApiResponseDTOExceededLimitsDTO';
import type { ApiResponseDTOThresholdCheckResponseDTO } from '../models/ApiResponseDTOThresholdCheckResponseDTO';
import type { ApiResponseDTOValidateOperationDTO } from '../models/ApiResponseDTOValidateOperationDTO';
import type { ValidateOperationRequestDTO } from '../models/ValidateOperationRequestDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LimitsApiService {

    /**
     * Get Exceeded Limits
     * Check which limits have been exceeded
     * @returns ApiResponseDTOExceededLimitsDTO OK
     * @throws ApiError
     */
    public static getExceededLimits(): CancelablePromise<ApiResponseDTOExceededLimitsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/limits/account/exceeded-limits',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get Account Status
     * Retrieve the account status
     * @returns ApiResponseDTOAccountLimitsStatusDTO OK
     * @throws ApiError
     */
    public static getAccountStatus(): CancelablePromise<ApiResponseDTOAccountLimitsStatusDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/limits/account/status',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Check Balance Threshold
     * Check if account balance has exceeded the threshold and return appropriate message
     * @returns ApiResponseDTOThresholdCheckResponseDTO OK
     * @throws ApiError
     */
    public static checkBalanceThreshold(): CancelablePromise<ApiResponseDTOThresholdCheckResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/limits/threshold/check',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Validate Credit Operation
     * Check if a credit operation will exceed limits.
     * @param requestBody
     * @returns ApiResponseDTOValidateOperationDTO OK
     * @throws ApiError
     */
    public static validateCreditOperation(
        requestBody: ValidateOperationRequestDTO,
    ): CancelablePromise<ApiResponseDTOValidateOperationDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/limits/validate/credit-operation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
